"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const character_1 = require("../slices/character");
const document_1 = __importDefault(require("../slices/document"));
const conversation_1 = __importDefault(require("../slices/conversation"));
const characters_slice_1 = require("../slices/characters-slice");
const user_1 = require("../slices/user");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
// @refactor IP
const conversation_slice_1 = require("../slices/conversation-slice");
const appState_1 = require("../slices/appState");
const subscription_1 = require("../slices/subscription");
const redux_persist_1 = require("redux-persist");
const fontSettings_1 = __importDefault(require("../slices/fontSettings"));
const userPersistConfig = {
    key: 'getUserOptions',
    storage: async_storage_1.default,
    blacklist: [
        'textStreaming',
        'lastMessage',
        'lastConversation',
        'chatAction',
        'isImageLoading',
        'generatedImageId'
    ],
};
const documentPersistConfig = {
    key: 'documents',
    storage: async_storage_1.default,
    blacklist: [
        'wasDocumentsFetched',
        'ids',
        'entities',
        'isConversationOpen',
        'isSourcesOpen',
        'streaming',
        'documentUploadComplete',
        'shareState',
        'isLoading',
        'isImageRegenerating',
        'isAudioConfigOpen',
        'documentJson',
    ],
};
const appStatePersistConfig = {
    key: 'appState',
    storage: async_storage_1.default,
    blacklist: ['shouldShowSidebar'],
};
const rootReducer = (0, toolkit_1.combineReducers)({
    fontSettings: fontSettings_1.default,
    getCharacterProfile: character_1.characterDetailsSlice.reducer,
    getSearchInputFlag: character_1.showSearchSlice.reducer,
    getUserOptions: (0, redux_persist_1.persistReducer)(userPersistConfig, user_1.userOptionsSlice.reducer),
    characters: characters_slice_1.getCharactersSlice.reducer, // load characters for category
    documents: (0, redux_persist_1.persistReducer)(documentPersistConfig, document_1.default.reducer),
    conversation: conversation_1.default,
    selectedConversation: conversation_slice_1.conversationSlice.reducer,
    subscriptionPlan: subscription_1.subscription.reducer,
    appState: (0, redux_persist_1.persistReducer)(appStatePersistConfig, appState_1.appStateSlice.reducer),
});
exports.default = rootReducer;
